import { render } from "./OTP.vue?vue&type=template&id=6a37e13e"
import script from "./OTP.vue?vue&type=script&lang=js"
export * from "./OTP.vue?vue&type=script&lang=js"

import "./OTP.vue?vue&type=style&index=0&id=6a37e13e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__